// intro-app/account/modal/loginModal.js

(function () {
    'use strict';
    var controllerId = 'loginModal';
    angular.module('intro-app').controller(controllerId, ['$scope', 'common', '$uibModalInstance', 'datacontext', '$translate', loginModalFn]);

    function loginModalFn($scope, common, $uibModalInstance, datacontext, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.error = null;
        $scope.item = {};  
        $scope.login = login;
        $scope.resendMail = resendMail;

        $scope.lingua = $translate.use();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function login() {
            $scope.error = null;
            return datacontext.account_login($scope.item).then(function (response) {
                if (response.status == 200) {
                    window.location = "/home/index";
                }
                else {
                    $scope.item.Password = "";
                    if (response.status == 403) { // Cambio password obbligatorio                        
                        var username = response.data.Username;
                        var uid = response.data.Uid;
                        window.location = "/index/newPassword?Username=" + username + "&Uid=" + uid;
                    }
                    else 
                        $scope.error = response.data;
                }
            });
        }

        function resendMail() {
            $scope.error = null;
            var obj = {};
            obj.Username = $scope.item.Username;
            obj.UID = "";

            return datacontext.account_resendMail(obj).then(function (response) {
                if (response.status == 200) {
                    $scope.resendSuccess = true;
                }
                else {
                    $scope.error = response.data;
                }
            });
        }
    }
})();